/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useTranslation } from 'react-i18next';
import type { TenantDataJobStatus } from '@/types/tenant-data.types';

export default function JobStatusBadge({ status }: { status: TenantDataJobStatus }) {
  const { t } = useTranslation('platform');
  return (
    <span className={`td-badge td-badge--${status.toLowerCase()}`}>
      {t(`tenantData.status.${status}`)}
    </span>
  );
}
